module.exports = __webpack_public_path__ + "media/images/svg/logotype-2640660112f67e71e39c825b9d8f33f7.svg";